import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../redux/store/store";

export const handleEditIcd = (dispatch: AppDispatch, orderId: string) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.CLINICAL_DATA_TABLE,
      metaData: { orderId: orderId },
    }),
  );
};
